const axios = require("axios")


async function postReq(url,data,callback){
  const post = await axios
  .post(url, {
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data
  }).catch(function (error) {
    console.log(error.toJSON());
  });
    return callback(post) 
}

function getnewUsers(token,callback){
  let url = process.env.VUE_APP_ROOT_API_URL +'api/admin/getnewUsers'
  axios
    .post(url, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { idToken: token}
    })
    .then(response => {
      if (response.status !== 200) { return alert("User Not Authorized") , location.reload();}
      return callback(response.data)
    })
    .catch(() => {})
}

function getGeneData(token, gene, callback) {
  let url = process.env.VUE_APP_ROOT_API_URL +"api/getGeneData"
  axios
    .post(url, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { idToken: token, geneName: gene }
    })
    .then(response => {
      return callback(response.data)
    })
    .catch(() => {})
}

function grantAdmin(token, gene, callback) {
  let url = process.env.VUE_APP_ROOT_API_URL +"api/grantAdmin"
  axios
    .post(url, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { idToken: token}
    })
    .then(response => {
      return callback(response.data)
    })
    .catch(() => {})
}

function replyMessage(data,callback){
  let url = process.env.VUE_APP_ROOT_API_URL + "api/messages/replyMessage";
  axios
  .post(url, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: data
  })
  .then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}


function editUserData(token, userObj, callback) {
  let url = process.env.VUE_APP_ROOT_API_URL +"api/editUserData"
  axios
    .post(url, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: {
        idToken: token,
        name: userObj.name,
        phone: userObj.phone,
        email: userObj.email
      }
    })
    .then(response => {
      return callback(response.data)
    })
    .catch(() => {})
}


export { postReq,getGeneData, editUserData,grantAdmin,replyMessage,getnewUsers}
